/**
 * MeetSection — meetings & booking from the card (#meet): the card owner connects Google
 * Calendar or Outlook once, visitors pick one of the free times on the card page, and the
 * meeting lands in the owner's calendar with its meeting link. Same layout as ScanSection
 * (.pg.scan grid, .sflow chips, .ben list); the illustration is the booking page + result.
 * Only live features: Meet links come with Google, Teams with Microsoft 365 work accounts.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar03Icon, CalendarCheckIn01Icon, Clock01Icon, Tick02Icon, Video01Icon } from '@hugeicons/core-free-icons';
import Icon from '../../components/v2/Icon.jsx';
import { useStr } from './useStr.js';
import saraPhotoUrl from './assets/sara-alotaibi.jpg';
import googleCalUrl from '../sched/assets/google-calendar.webp';
import outlookCalUrl from '../sched/assets/outlook-calendar.svg';
import './meet.css';

const L = ({ children, className = '' }) => <span className={`ltr${className ? ` ${className}` : ''}`}>{children}</span>;

const DAYS = [['أحد', 'Sun', '25'], ['إثنين', 'Mon', '26'], ['ثلاثاء', 'Tue', '27'], ['أربعاء', 'Wed', '28'], ['خميس', 'Thu', '29']];
const TIMES = ['9:00', '10:30', '11:00', '1:30', '3:00', '4:30'];

export default function MeetSection() {
  const { t, ar, arrow } = useStr();
  const sep = <span className="sep" aria-hidden="true"><Icon icon={arrow} /></span>;
  return (
    <section className="sx">
      <div className="wrap">
        <div className="pg scan meet" id="meet">
          <div className="tx">
            <div className="eb"><Icon icon={Calendar03Icon} />{t('meetEb')}</div>
            <h2>{t('meetTitle')}</h2>
            <p>
              {ar
                ? <>اربط تقويم <L>Google</L> أو <L>Outlook</L> مرة وحدة. اللي يفتح بطاقتك يشوف أوقاتك الفاضية بس، يختار اللي يناسبه، والاجتماع ينزل في تقويمك مع رابطه.</>
                : <>Connect <L>Google</L> or <L>Outlook</L> Calendar once. Anyone who opens your card sees only your free times, picks one, and the meeting lands in your calendar with its link.</>}
            </p>
            <div className="sflow">
              <span className="sfs"><span className="n ltr">01</span>{t('mf1')}</span>
              {sep}
              <span className="sfs on"><span className="n ltr">02</span>{t('mf2')}</span>
              {sep}
              <span className="sfs"><span className="n ltr">03</span>{t('mf3')}</span>
            </div>
            <ul className="ben">
              <li>
                <Icon icon={Tick02Icon} />
                <span>{ar
                  ? <>رابط <L>Google Meet</L> تلقائي مع تقويم <L>Google</L>، ورابط <L>Teams</L> مع حسابات <L>Microsoft 365</L>.</>
                  : <>An automatic <L>Google Meet</L> link with <L>Google</L> Calendar, and a <L>Teams</L> link with <L>Microsoft 365</L> accounts.</>}</span>
              </li>
              <li><Icon icon={Tick02Icon} /><span>{t('mben2')}</span></li>
              <li><Icon icon={Tick02Icon} /><span>{t('mben3')}</span></li>
            </ul>
            <Link className="btn lg" to="/signup"><Icon icon={CalendarCheckIn01Icon} />{t('meetCta')}</Link>
          </div>

          <div className="scanner mtv" aria-hidden="true">
            <div className="bk">
              <div className="bkh">
                <img src={saraPhotoUrl} alt="" />
                <div>
                  <b>{t('mBookWith')}</b>
                  <span><Icon icon={Clock01Icon} /><L className="num">30</L> {t('mMin')} · <L>Google Meet</L></span>
                </div>
              </div>
              <div className="days">
                {DAYS.map(([dAr, dEn, n], i) => (
                  <span key={n} className={i === 2 ? 'on' : i === 4 ? 'off' : ''}>
                    <small>{ar ? dAr : dEn}</small><b className="num ltr">{n}</b>
                  </span>
                ))}
              </div>
              <div className="slots">
                {TIMES.map((tm, i) => (
                  <span key={tm} className={i === 1 ? 'on' : ''}><L className="num">{tm}</L> {i < 3 ? t('am') : t('pm')}</span>
                ))}
              </div>
              <span className="btn dark full">{t('mConfirm')}</span>
            </div>
            <div className="ext">
              <div className="exh">
                <span className="d"><Icon icon={Tick02Icon} /></span>
                <div><b>{t('mBooked')}</b><span>{t('mBookedSub')}</span></div>
              </div>
              <div className="evt">
                <div className="et">
                  <b>{t('mEvt')}</b>
                  <span>{t('mEvtWhen')}</span>
                </div>
                <div className="lnk"><Icon icon={Video01Icon} /><L>meet.google.com/abc-defg-hij</L></div>
              </div>
              <div className="cals">
                <span><img src={googleCalUrl} alt="" /><L>Google Calendar</L></span>
                <span><img src={outlookCalUrl} alt="" /><L>Outlook</L></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
